import { render, staticRenderFns } from "./ModalRemoveAccount.vue?vue&type=template&id=42486b00&scoped=true&lang=pug&"
import script from "./ModalRemoveAccount.vue?vue&type=script&lang=ts&"
export * from "./ModalRemoveAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRemoveAccount.vue?vue&type=style&index=0&id=42486b00&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42486b00",
  null
  
)

export default component.exports